module.exports = __webpack_public_path__ + "img/violet_044.9892b525.png";